var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40pt",
    height: "52pt",
    viewBox: "0 0 50 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "image11",
    width: 50,
    height: 65,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABBCAYAAACTiffeAAAABmJLR0QA/wD/AP+gvaeTAAAEHElEQVRogeWb63KbMBCFPyC2c2mbNknz/s+Ym9vEhv5YrRHLChTHNmZ6ZjSI4KHncHZXAqkFcAEUoRH1tZUD5/baB7AJbQvUQBPdtwSq8G9eAItwXVud6Hvnet8GaGIRccMh6YkA+Av8Ad6jm+eiAJbAZTiWgTCmr+cqqDBidjfyxAwJaIB1aJ8lPyTqKrSCYXd6TW0eElDSFbMGnpAwOjQ+wv1Bws6GexIFYmtOTmyAZ7p2HxMl8B150KM5U9HGZvz0rYg34IXDhVEOGiT/CrruKDrRo0K8cFIRL0gyT4UPpAKu6BekHSoktCx5PT4h1WhqbJHQ1jQAxxG9aMU8c5yE3hc1IsjmNCCOXNEVUQKvSHyeG7ZI7sRhBlB4IfVOWwLPEWvkIcecS+tEg+TFueMZ4brjboWcusTuiwbh6grZcN4hZbFGcqYn5GVKVnviGSOkZtpBb1/8QbjvhLxNy+dLeCMIqZBxY654BSpN8s3EZL6CDbAtmWduWKx1JJ873ivaMWTOKKvQOdVb39GgQuYwLfl/MPh1YiYodECcO6oS+fgwd6xK5B147rgsgZupWRwANyVwzbwTvgCudBr/bWIyX8E3wjS+AW4nJvMV/AQaFXLDPKvXCkmNnZAGuJuU0n64I/DX9/WG9hP+XHCB5EcD1CpExczJlXvadZI6Di11ZQ4D5IrWjU5oxa48TEYvH7+J3MCElrYl8GMqhhm4RTh2eHtCauAX5zkrrpBxw/LdlrQL+xpa+tr7+/Q8R6GcYq41UFfIgKKIX3kX4XguCz63SILHInYrvLpiZaGTyEvku9f2+DwHsUSKULw03RMSl1tvCfgK+Sw51QeKEnikuxuid6yQmqzwyJZImE31ofuBbpVKOhJPFlPvJbpgf+p8+UmYFNIX0nMkZ9ZbIM5tON2S9Q2S4J3qhC+kqWirU85b4jXiyrGTf0U0syVTSGrG6yU+iJg1x/vMWtGOFykRvS1QnpAhZ3SRXivZoZGqUINuEIR4U5HCHO01LduHrGQF4oRua8oWQRBSmpvZfsqhCySWDyXmEclXO4+y+7PcnXVWiCWe2sGm/QWHEfMQ7uPlgeeIG1pWSEqM9q1TC6SE7yvmHsm5FNlRESCxntovmBLgYRHaZ3dO3CHjhfcqkSLeE0FwZCyx7THVlkje5IqJRaR2j47t/YUotFJhZM9znFtlirmn64StUDlbZcGElkd4qG+dsH9bMhxm97TzpyGyQ05h+6nQ8p7+WHjFv0uJiUXYJ5/TFFZQz5GxUT0l0vu7rWZanbwn74VUjqiOI58h6v3OC7NYzAJxwYr4rBueK7ujJyQ+Hxrpx0Qo9H8m5FSlocoUC4jPsUI8smOCvIQfQq6YseSO7+cKSYmx1yzxlCupUBgb5Oxv3byIif0DWW8O36dj2XsAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.235294
    },
    d: "M 28.125 63.296875 C 28.125 62.445312 26.726562 61.757812 25 61.757812 C 23.273438 61.757812 21.875 62.445312 21.875 63.296875 C 21.875 64.148438 23.273438 64.835938 25 64.835938 C 26.726562 64.835938 28.125 64.148438 28.125 63.296875 Z M 28.125 63.296875 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image11"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      fill: "rgb(15.294118%,54.117647%,77.647059%)",
      fillOpacity: 1,
      strokeWidth: 2.957,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 23.66 1.477516 C 29.785722 1.477516 35.331034 3.960896 39.345841 7.974819 C 43.35695 11.988742 45.84125 17.533207 45.84125 23.659129 C 45.84125 31.95707 38.288534 43.068509 23.656303 57.102234 C 9.031466 43.068509 1.47875 31.953319 1.47875 23.659129 C 1.47875 17.533207 3.96305 11.988742 7.974159 7.974819 C 11.988966 3.960896 17.534278 1.481267 23.66 1.481267 Z M 23.66 1.477516 ",
    transform: "matrix(1.056636,0,0,1.041297,0,0.164591)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.8125 23.261719 C 32.8125 27.515625 29.316406 30.960938 25 30.960938 C 20.683594 30.960938 17.1875 27.515625 17.1875 23.261719 C 17.1875 19.007812 20.683594 15.5625 25 15.5625 C 29.316406 15.5625 32.8125 19.007812 32.8125 23.261719 Z M 32.8125 23.261719 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.adfe9a837498f9c836a98b9ea0fee675.svg";
export { ForwardRef as ReactComponent };